
define(['jquery', 'underscore', 'common/component/validators'], function($, _) {
  var messages, rules, validator;
  validator = null;
  rules = {};
  messages = {};
  $.fn.resetForm = function() {
    return $(this).find('.control-group').removeClass('error');
  };
  return {
    init: function(form, helperClass, customErrorPlacement) {
      if (!helperClass) {
        helperClass = 'help-inline';
      }
      validator = form.validate({
        onkeyup: false,
        errorPlacement: function(error, element) {
          if (_.isFunction(customErrorPlacement)) {
            return customErrorPlacement(error, element);
          } else {
            return error.insertAfter(element);
          }
        },
        errorElement: 'span',
        errorClass: 'custom-error',
        showErrors: function(errorMap, errorList) {
          this.defaultShowErrors();
          $('input.custom-error').closest('.control-group').addClass('error');
          $('select.custom-error').closest('.control-group').addClass('error');
          $('span.custom-error').addClass(helperClass);
          $('input:visible').not('.custom-error').closest('.control-group').removeClass('error');
          return $('select:visible').not('.custom-error').closest('.control-group').removeClass('error');
        },
        rules: rules,
        messages: messages
      });
      return validator;
    },
    addRules: function(r) {
      return rules = r;
    },
    addMessages: function(m) {
      return messages = m;
    },
    lib: $.validator
  };
});
